module.exports = __webpack_public_path__ + "media/home-video-xs.4ab83f7a.mp4";